import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import { Caract_anteproy_loteo } from "src/app/models/caract_anteproy_loteo.model";
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-caract_fusion",
    templateUrl: "./caract_fusion.component.html",
    styleUrls:['./caract_fusion.component.css'],
    providers: [FormService]
})

export class Caract_fusionComponent {
    @ViewChild('openModal') openModal:TemplateRef<any>;
      public rows = [];
      public actualRow;
      public actualRow2;
      public caract_fusion: Caract_anteproy_loteo;
      public form;
      public temp_carct_loteo;
      public matcher = new FormService();
      public numeroForms= 0;
      public totalsup = 0 ;

    constructor(private dialog: MatDialog){

        this.form = new FormGroup({

            caract_fusion: new FormControl(''),
            sup_ant_loteo: new FormControl(''),
            num_anteproy_act: new FormControl(''),
            sup_anteproy_act: new FormControl(''),
            hoja_anexa_loteo: new FormControl('')
        })
        if(!JSON.parse(localStorage.getItem("caract_fusion"))){
            localStorage.setItem("caract_fusion", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("caract_fusion"));
            
            this.form.controls['sup_ant_loteo'].setValue(this.rows[0]?this.rows[0].sup_ant_loteo:'')
            this.form.controls['num_anteproy_act'].setValue(this.rows[0]?this.rows[0].num_anteproy_act:'')
            this.form.controls['sup_anteproy_act'].setValue(this.rows[0]?this.rows[0].sup_anteproy_act:'')
            this.form.controls['hoja_anexa_loteo'].setValue(this.rows[0]?this.rows[0].hoja_anexa_loteo:'')

        }
        this.caract_fusion = {sup_ant_loteo:'',num_anteproy_act:'',sup_anteproy_act:'',hoja_anexa_loteo:''};
        this.temp_carct_loteo = {sup_ant_loteo:'',num_anteproy_act:'',sup_anteproy_act:'',hoja_anexa_loteo:''};  
    }

    add_caract_fusion(){
        

        this.actualRow = localStorage.getItem("caract_fusion");

        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({

            caract_fusion: this.form.value.caract_fusion,
            sup_ant_loteo: this.form.value.sup_ant_loteo,
            num_anteproy_act: this.form.value.num_anteproy_act,
            sup_anteproy_act: this.form.value.sup_anteproy_act,
            hoja_anexa_loteo: this.form.value.hoja_anexa_loteo
            
        })
        localStorage.setItem("caract_fusion", JSON.stringify(this.rows));
        this.actualRow2 = localStorage.getItem("caract_fusion");
      
        //this.form.reset();
    }

    get_caract_fusion(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
               this.temp_carct_loteo.id = id;
               this.temp_carct_loteo.caract_fusion =  this.rows[x].caract_fusion;
               this.temp_carct_loteo.sup_ant_loteo =  this.rows[x].sup_ant_loteo;
               this.temp_carct_loteo.num_anteproy_act =  this.rows[x].num_anteproy_act;
               this.temp_carct_loteo.sup_anteproy_act =  this.rows[x].sup_anteproy_act;
               this.temp_carct_loteo.hoja_anexa_loteo =  this.rows[x].hoja_anexa_loteo;

               this.dialog.open(this.openModal);
            }
        }
    }

    cleanData(){
        this.temp_carct_loteo = {sup_ant_loteo:"",num_anteproy_act:"",sup_anteproy_act:"",hoja_anexa_loteo:""};
    }

    savecaract_fusion(){
       var  id = this.temp_carct_loteo.id;
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("caract_fusion", JSON.stringify(this.rows));
           
                    $("#clasif_modal").modal("hide");
                    this.actualRow = localStorage.getItem("caract_fusion");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({

                        sup_ant_loteo: this.temp_carct_loteo.sup_ant_loteo,
                        num_anteproy_act: this.temp_carct_loteo.num_anteproy_act,
                        sup_anteproy_act: this.temp_carct_loteo.sup_anteproy_act,
                        hoja_anexa_loteo: this.temp_carct_loteo.hoja_anexa_loteo

                    })
                    localStorage.setItem("caract_fusion", JSON.stringify(this.rows));
                    this.temp_carct_loteo = {sup_ant_loteo:"",num_anteproy_act:"",sup_anteproy_act:"",hoja_anexa_loteo:""};
                    this.dialog.closeAll();
                }
            }         
    }

    delete_caract_fusion(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("caract_fusion", JSON.stringify(this.rows));
            }
        }
    }

}